<template>
    <a v-if="messageProp" href="#" class="auth__office-link">
        <span class="auth__office-count auth__office-count--secondary" v-html="messages.length"></span>
        <svg width="23" height="16" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="22" height="13" rx="1.5" stroke="#929292"/>
            <path d="M11.2981 7.59144L11.053 8.02729L11.2981 7.59144ZM0.662684 2.18584L11.053 8.02729L11.5431 7.1556L1.15275 1.31416L0.662684 2.18584ZM12.5554 8.00868L22.3477 2.17964L21.8362 1.32036L12.0439 7.1494L12.5554 8.00868ZM11.053 8.02729C11.5211 8.29041 12.094 8.28331 12.5554 8.00868L12.0439 7.1494C11.8901 7.24094 11.6991 7.24331 11.5431 7.1556L11.053 8.02729Z" fill="#929292"/>
        </svg>
    </a>
    <div v-else class="auth__office-item auth__office-item--notice"
         @mouseover="hover = true"
         @mouseleave="hover = false"
    >
        <a href="#" class="auth__office-link">
            <span class="auth__office-count auth__office-count--secondary">{{ messages.length }}</span>
            <svg width="23" height="16" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="22" height="13" rx="1.5" stroke="#929292"/>
                <path d="M11.2981 7.59144L11.053 8.02729L11.2981 7.59144ZM0.662684 2.18584L11.053 8.02729L11.5431 7.1556L1.15275 1.31416L0.662684 2.18584ZM12.5554 8.00868L22.3477 2.17964L21.8362 1.32036L12.0439 7.1494L12.5554 8.00868ZM11.053 8.02729C11.5211 8.29041 12.094 8.28331 12.5554 8.00868L12.0439 7.1494C11.8901 7.24094 11.6991 7.24331 11.5431 7.1556L11.053 8.02729Z" fill="#929292"/>
            </svg>
        </a>
        <transition name="fade">
            <div class="notice notice--messages" v-show="hover">
                <div class="notice__item">
                    <div class="notice__item-header d-flex">
                        <div class="notice__item-title">
                            Мои сообщения
                        </div>
                        <a href="#" class="notice__see-all">Смотреть все</a>
                    </div>
                    <div class="notice__item-body" v-if="messages.length">

                        <a  :href="message.link" class="notice__message d-flex" v-for="message in messages" :key="messages.id">
                            <div class="notice__message-img">
                                <img :src="message.thumb" :alt="getPMuser(message)" v-if="message.thumb.length">
                                <span v-else class="pm" v-html="getPMuser(message)"></span>
                            </div>
                            <div class="notice__message-content">
                                <div class="notice__message-text" >
                                    <span class="notice__message-name" :class="(message.newMessage ? 'notice__message-name--new-message' : '')" v-html="message.f_name + ' ' + message.l_name + ' '"></span>
                                    <div v-html="message.text"></div>
                                </div>
                                <div class="notice__message-time" v-html="message.date"></div>
                            </div>
                        </a>

                    </div>
                    <div v-else class="notice__item-body notice__item-body--empty d-flex">
                        У вас нет новых сообщений
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
    export default {
        name: 'Messages',
        props:['messageProp','data'],
        data(){
            return {
                hover: false,
                messages: [],
            }
        },


        mounted() {

            this.getMessages()

        },
        methods:{

            getMessages(){

                this.messages = this.data;


            },

            getPMuser(user){
                return (user.f_name.trim().length ? user.f_name[0].toUpperCase() : '')  +  (user.l_name.trim().length ? user.l_name[0].toUpperCase() : '')
            },
        },


    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/helpers';

    .notice--messages{

        .notice__message{
            padding: 25px 15px;
        }

        .notice__message-name{
            &--new-message{
                position: relative;
                padding-right: 20px;
                &::before{
                    position: absolute;
                    right: 0;
                    top: -5px;
                    display: block;
                    content: '';
                    width: 14px;
                    height: 10px;
                    background: url("/images/menu/new-mail.svg") no-repeat center/contain;
                }
            }

        }
        .notice__message-time{
            position: absolute;
            right: 15px;
            top: 20px;
            color: #6C4DBB;
        }

    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }

</style>
